import { useEffect, useState } from "react";

import { IdentifierMode } from "./models";

import FromIdentifier, { FromIdentifierProps } from "./FromIdentifier";
import IdentifierModeRadio, {
  IdentifierModeRadioProps,
} from "./IdentifierModeRadio";

import useAssistantCommunicationBinding from "V2.0/HomePages/HomeCampaign/useAssistantCommunicationBinding";

export default useBulkCampaignFromIdentifier;

function useBulkCampaignFromIdentifier(workspaceId, assistantId, campaignType) {
  const [identifierMode, setIdentifierMode] = useState<IdentifierMode>(
    IdentifierMode.FROM_IDENTIFIER,
  );

  const {
    fromIdentifier,
    setFromIdentifier,
    identifierOptions,
    availableIdentifiers,
  } = useAssistantCommunicationBinding({
    assistantId,
    workspaceId,
    campaignType,
  });

  useEffect(() => {
    if (fromIdentifier) {
      setFromIdentifier("");
    }
  }, [identifierMode]);

  const fromIdentifierComponentProps: FromIdentifierProps = {
    campaignType,
    identifierOptions,
    fromIdentifier,
    onChange: (e) => setFromIdentifier(e.target.value),
  };

  const identifierModeComponentProps: IdentifierModeRadioProps = {
    identifierMode,
    setIdentifierMode,
    identifiersAvailable: availableIdentifiers.length > 0,
  };

  return {
    fromIdentifier,
    availableIdentifiers,
    rotateIdentifiers: identifierMode === IdentifierMode.ROTATE_IDENTIFER,
    fromIdentifierComponentProps,
    identifierModeComponentProps,
    FromIdentifierComponent: FromIdentifier,
    IdentifierModeComponent: IdentifierModeRadio,
  };
}
